import { UserOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Tag } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

const DelegateUserNameWrapper = styled.span`
  font-size: 16px;
  margin-right: 4px;
  .anticon {
    margin-right: 4px;
    opacity: 0.65;
    font-size: 1.2em;
  }
`;

export interface IDelegateUserNameProps {
  name?: string;
}

/**
 * Nome di un modulo con icona per vista in lista nel frontend
 */
export function DelegateUserName(props: IDelegateUserNameProps) {
  const { name } = props;
  const { t } = useTranslation();

  if (!name)
    return (
      <Tag color="default">
        {t('delegate-username.nessuno', 'Nessuno')}
      </Tag>
    );

  return (
    <DelegateUserNameWrapper>
      <UserOutlined aria-hidden />
      {name}
    </DelegateUserNameWrapper>
  );
}
